var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPropertyFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 82.443,
    viewBox: "0 0 188 82.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163012",
    "data-name": "Group 163012",
    transform: "translate(-12510.678 11996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M184.473,30.3,217.259,6.723,250.046,30.3l4.167-3.729L217.259,0,180.307,26.567Z",
    transform: "translate(12398.377 -11996)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M346.394,116.559l16.92,11.257,2.027-1.951-19.07-12.687",
    transform: "translate(12295.009 -12066.491)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2478",
    "data-name": "Rectangle 2478",
    width: 9.208,
    height: 8.577,
    transform: "translate(12616.194 -11968.602)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2479",
    "data-name": "Rectangle 2479",
    width: 9.208,
    height: 8.577,
    transform: "translate(12604.939 -11968.602)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M223.673,90.834V61.885l19.22-9.277,16.959,9.277V43.319L231.558,22.976,203.264,43.319V90.963m16.165-50.4h23.328v10.87H219.429Z",
    transform: "translate(12384.078 -12010.31)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2480",
    "data-name": "Rectangle 2480",
    width: 3.173,
    height: 26.676,
    transform: "translate(12648.18 -11946.058)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2481",
    "data-name": "Rectangle 2481",
    width: 2.447,
    height: 30.663,
    transform: "translate(12604.908 -11950.045)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M104.079,101.137,123.4,87.244l19.324,13.893,2.456-2.2L123.4,83.281,101.624,98.94Z",
    transform: "translate(12447.383 -12047.87)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M148.5,110.127v27.649H136.9V119.04H126.233v18.737H115.152v-27.65l16.676-11.989Z",
    transform: "translate(12438.958 -12057.123)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2482",
    "data-name": "Rectangle 2482",
    width: 9.554,
    height: 20.739,
    transform: "translate(12628.927 -11940.497)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2483",
    "data-name": "Rectangle 2483",
    width: 9.554,
    height: 20.739,
    transform: "translate(12617.474 -11940.497)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2484",
    "data-name": "Rectangle 2484",
    width: 4.772,
    height: 8.034,
    transform: "translate(12559.172 -11963.864)",
    fill: "#ceced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M188,199.984c-21.622-6.847-55.679-11.264-94-11.264s-72.38,4.417-94,11.264c25.881-2.959,58.522-4.724,94-4.724s68.119,1.765,94,4.724",
    transform: "translate(12510.678 -12113.541)",
    fill: "#ceced6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPropertyFound);
export default __webpack_public_path__ + "static/media/NoPropertyFound.e2c8dfc645489ade3a70c0331e94993c.svg";
export { ForwardRef as ReactComponent };